import { useEffect, useState } from "react";
import { HardDrive } from "lucide-react";
import { api } from "@/lib/api";

export const fmtBytes = (b) => {
  if (b == null) return "—";
  const u = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  while (b >= 1024 && i < u.length - 1) { b /= 1024; i++; }
  return `${b.toFixed(b >= 100 || i === 0 ? 0 : 1)} ${u[i]}`;
};

const STATE = { nearing: "Nearly full", critical: "Almost out of space", exceeded: "Storage full" };

export const OneDriveQuota = ({ refreshKey }) => {
  const [q, setQ] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { api.get("/onedrive/quota").then((r) => setQ(r.data)).catch(() => setError(true)); }, [refreshKey]);
  if (error) return null;
  if (!q) return <div className="mt-4 h-[74px] animate-pulse rounded-md bg-zinc-50" />;
  const pct = (v) => (q.total ? Math.min(100, (v / q.total) * 100) : 0);
  const other = Math.max(0, (q.used || 0) - q.music);
  const warn = STATE[q.state];
  return (
    <div className="mt-4 rounded-md bg-zinc-50 px-4 py-3" data-testid="onedrive-quota">
      <div className="flex items-center justify-between gap-3">
        <p className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-zinc-400"><HardDrive size={11} />Storage</p>
        {warn && <span className="rounded-full bg-red-50 px-2 py-0.5 text-[10px] text-red-700" data-testid="onedrive-quota-warning">{warn}</span>}
      </div>
      <p className="mt-1 text-sm" data-testid="onedrive-quota-text">
        <span className="font-medium">{fmtBytes(q.used)}</span> of {fmtBytes(q.total)} used
        <span className="font-mono text-xs text-zinc-500"> · {fmtBytes(q.remaining)} free</span>
      </p>
      <div className="mt-2 flex h-2 overflow-hidden rounded-full bg-zinc-200" data-testid="onedrive-quota-bar">
        <div className="bg-amber-500 transition-[width] duration-700" style={{ width: `${pct(q.music)}%` }} title={`Music in library: ${fmtBytes(q.music)}`} />
        <div className="bg-zinc-500 transition-[width] duration-700" style={{ width: `${pct(other)}%` }} title={`Other files: ${fmtBytes(other)}`} />
      </div>
      <div className="mt-2 flex flex-wrap gap-4 text-[11px] text-zinc-500">
        <span className="flex items-center gap-1.5" data-testid="onedrive-quota-music"><span className="h-2 w-2 rounded-full bg-amber-500" />Music in library {fmtBytes(q.music)}</span>
        <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-zinc-500" />Other files {fmtBytes(other)}</span>
        {q.deleted ? <span>Recycle bin {fmtBytes(q.deleted)}</span> : null}
      </div>
    </div>
  );
};
